import type { clients as Fr } from '../fr/clients';

/** « clients » in English — typed on the French: a missing sentence does not compile. */
export const clients: typeof Fr = {
  titre: 'Customers',
  sousTitreVide: 'Every rental starts from a customer record',
  fiches: (n: number) => `${n} ${n === 1 ? 'record' : 'records'}`,
  nouveau: 'New customer',
  rechercher: 'Search by name or phone',
  rechercherExemple: 'Bouzidi, 0661…',
  aucunCorrespond: 'No matching customer',
  aucuneFiche: 'No customer records',
  premiere: 'Create my first record',
  autreOrthographe: 'Try another spelling, or just the first digits of the phone number.',
  videTexte: 'The record holds the date of birth and the licence date: they trigger the eligibility rule blocks — minimum age 28, licence held for 5 years. It can also be created directly from a new rental.',
  col: { nom: 'Name', telephone: 'Phone', piece: 'ID document', permis: 'Licence issued on' },
  societe: 'Company',
  listeNoire: 'Blacklist',
  compteATerme: 'On-account customer',
  ouvrir: 'Open',
  retirerTitre: (n: string) => `Remove ${n} from the blacklist`,
  mettreTitre: (n: string) => `Blacklist ${n}`,
  retirerTexte: 'The customer will be able to rent again. The reason for removal stays in the audit log.',
  mettreTexte: 'No rental can be created for this customer any more — the screen will refuse and say why. The decision and its reason stay in the audit log, with your name.',
  motif: 'Reason',
  motifAide: 'Required. This is the text the agent will read when refusing.',
  motifRetraitExemple: 'E.g. debt settled on 30/08, customer accepted again.',
  motifMiseExemple: 'E.g. two vehicles returned damaged, balance unpaid since March.',
  annuler: 'Cancel',
  enregistrementImpossible: 'Unable to save.',
  retirer: 'Remove from blacklist',
  mettre: 'Add to blacklist',
  clientListeNoire: 'Customer is blacklisted',
  modifierFiche: 'Edit record',
  article01: 'Eligibility rule',
  conforme: 'Eligible',
  conformeTexte: (age?: number, permis?: number) => `${age} years old · licence held for ${permis} ${permis === 1 ? 'year' : 'years'}.`,
  coordonnees: 'Contact details',
  telephone: 'Phone',
  email: 'Email',
  adresse: 'Address',
  naissance: 'Born',
  lieuNaissance: (l: string) => `in ${l}`,
  permis: 'Driving licence',
  historique: (n: number) => `History — ${n} ${n === 1 ? 'rental' : 'rentals'}`,
  colHisto: { numero: 'No.', vehicule: 'Vehicle', periode: 'Period', total: 'Total' },
};
